// formHttp.ts
import type { FormApi } from "./formSpec"

export async function safeJson(res: Response): Promise<unknown> {
    try {
        return await res.json()
    } catch {
        return null
    }
}

export function extractMessage(payload: unknown, fallback: string): string {
    if (!payload) return fallback
    if (typeof payload !== "object") return fallback
    const p = payload as any
    if (typeof p.message === "string") return p.message
    if (typeof p.error === "string") return p.error
    return fallback
}

export function applyFieldErrors(form: FormApi, payload: unknown) {
    if (!payload) return
    if (typeof payload !== "object") return
    const p = payload as any
    const fe = p.fieldErrors
    if (!fe) return
    if (typeof fe !== "object") return

    Object.keys(fe).forEach((k) => {
        const v = fe[k]
        if (typeof v !== "string") return
        form.setError(String(k), v)
    })
}
